import numeral from 'numeral';

/**
 * Locale prefix.
 * @type {String}
 */
export const LOCALE_FR = 'fr';

/**
 * Initialize numeral configuration.
 */
export default function initNumeral() {
    numeral.register('locale', LOCALE_FR, {
        delimiters: {
            thousands: ' ',
            decimal: ',',
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't',
        },
        ordinal: (number) => (number === 1 ? 'er' : 'ème'),
        currency: {
            symbol: '€',
        },
    });

    // load a language
    numeral.locale(LOCALE_FR);
    numeral.defaultFormat('0,0');
}
